import { render, staticRenderFns } from "./PartsOfSpeechPreview.vue?vue&type=template&id=2eef2ff2&lang=pug&"
import script from "./PartsOfSpeechPreview.vue?vue&type=script&lang=js&"
export * from "./PartsOfSpeechPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports